import { format, formatDistanceStrict } from 'date-fns';

/**
 *
 * @param {string} date
 * @param {string} pattern like dd.MM.yyyy
 *
 * @returns {string} formated by pattern date
 */
const prettyDate = (date, pattern = 'dd.MM.yyyy') => {
  return format(new Date(date), pattern);
};

/**
 *
 * @param {string} leftDate
 * @param {string} rightDate
 *
 * @returns {string} diff between two dates
 */
const diff = (leftDate, rightDate) => {
  if (!leftDate || !rightDate) {
    return;
  }

  return formatDistanceStrict(new Date(leftDate), new Date(rightDate));
};

export { prettyDate, diff };
